import { useQuery } from "@tanstack/react-query";
import { APIErrorResponse } from "src/types/generic";
import apiClient from "../apiClient";

export interface ILedgerParams {
  page?: number;
  start_date?: string;
  end_date?: string;
}

export const useGetGeneralLedgerList = (params: ILedgerParams) =>
  useQuery<any, APIErrorResponse, any>({
    queryKey: [
      "get-general-ledger-list",
      params.start_date,
      params.end_date,
      params.page,
    ],
    queryFn: async () => {
      return apiClient.get(`/api/general-ledgers`, { params });
    },
  });
